import React, { useEffect, useState } from "react";
import moment from "moment";
import DashboardTab from "../tables/DashboardTab";
import { RiWallet3Line } from "react-icons/ri";
import { FaArrowUpLong } from "react-icons/fa6";
import {
  FaSearch,
  FaCloudflare,
  FaRegUserCircle,
  FaWaveSquare,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getAllActivites } from "../store/actions/activities";
import { IoClose } from "react-icons/io5";
import { MdFilterList } from "react-icons/md";
import { getUserCountStatics } from "../store/actions/user";

const UserActivity = () => {
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("all");
  const [activityList, setActivityList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [dates, setDates] = useState({
    fromDate: new Date().toISOString().split("T")[0],
    toDate: new Date().toISOString().split("T")[0],
  });
  const [statCount, setStatCount] = useState("");
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [filterQuery, setFilterQuery] = useState({
    limit: "10",
    page: "1",
    createdAt: {
      lte: moment(dates.toDate).endOf("day").toISOString(),
      gte: moment(dates.fromDate)
        .startOf("day")
        .subtract(7, "days")
        .toISOString(),
    },
  });
  const [isModalFilter, setIsModalFilter] = useState(false);

  // redux logic
  const activities = useSelector((state) => state.activities);

  const getActivityList = () => {
    dispatch(getAllActivites(filterQuery));
  };

  useEffect(() => {
    getActivityList();
  }, [dispatch, filterQuery, setFilterQuery]);

  useEffect(() => {
    dispatch(getUserCountStatics()).then((result) => {
      if (result?.payload?.success) {
        //  console.log(result?.payload?.counts);
        setStatCount(result?.payload?.counts);
      }
    });
  }, [dispatch]);

  useEffect(() => {
    setActivityList(activities.activityList);
  }, [activities]);

  const userHeader = [
    { key: "user" },
    { key: "Types" },
    { key: "message" },
    { key: "date" },
  ];
  const handleTabClick = (tab) => {
    if (tab === "all") {
      delete filterQuery.types;
      setFilterQuery({ ...filterQuery });
    } else {
      setFilterQuery({ ...filterQuery, types: tab });
    }
    setActiveTab(tab);
  };
  const handleSearchText = (e) => {
    setSearchText(e.target.value);
  };
  const handleSearch = (e) => {
    e.preventDefault();
    setFilterQuery({
      ...filterQuery,
      keyword: e.target.defaultSearch.value,
      keywordName: ["types", "message"],
    });
    setShowCloseButton(true);
  };
  const handleClearSearch = () => {
    delete filterQuery.keyword;
    delete filterQuery.keywordName;
    setFilterQuery({ ...filterQuery });
    setSearchText("");
    setShowCloseButton(false);
  };
  const toggleModalFilter = () => {
    setIsModalFilter(!isModalFilter);
  };
  const handleFilter = (e) => {
    e.preventDefault();
    setDates({
      fromDate: new Date(e.target.dateFrom.value).toISOString().split("T")[0],
      toDate: new Date(e.target.dateTo.value).toISOString().split("T")[0],
    });
    setFilterQuery({
      ...filterQuery,
      createdAt: {
        lte: moment(dates.toDate).endOf("day").toISOString(),
        gte: moment(dates.fromDate).startOf("day").toISOString(),
      },
    });
    setIsModalFilter(false);
  };

  return (
    <div className="relative">
      <div className=" bg-top p-2  fixed  w-full lg:max-w-[calc(100%-16rem)] z-10 !bg-[#cbd5e0]">
        <div className="w-full flex items-center justify-between p-1  gap-4">
          <div className="text-text text-lg font-medium">User Activity</div>
          <div className="relative ">
            <form className=" flex w-full " onSubmit={handleSearch}>
              <span className="absolute inset-y-0 left-0 flex items-center pl-3  text-gray-500">
                <FaSearch />
              </span>

              <input
                type="text"
                id="default-search"
                value={searchText}
                onChange={handleSearchText}
                name="defaultSearch"
                placeholder="Search..."
                className="w-[275px]  pl-10 pr-4 py-2 text-gray-500 border border-gray-300 rounded-lg focus:outline-none focus:ring-0 focus:ring-blue-500"
              />
              <button
                type="submit"
                className="text-white  absolute right-0 bottom-1 top-1 bg-[#02256d] hover:bg-blue-800  focus:outline-none focus:ring-0 font-medium rounded-lg text-sm px-4 py-0 mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Search
              </button>
              {showCloseButton && (
                <button
                  type="submit"
                  className="text-red-600 text-bold absolute right-20 bottom-1 top-1  focus:outline-none focus:ring-0 font-medium rounded-lg text-sm px-2 py-0 mr-2  "
                  onClick={handleClearSearch}
                >
                  X
                </button>
              )}
            </form>
          </div>
        </div>       
      </div>
      <div className="pt-16  ">
        <div className="flex flex-col sm:flex-row justify-between items-center w-full gap-4 bg-[#cbd5e0] p-2">
          {/* Title Section */}
          <div className="flex gap-10">
            <div>
              <h2 className="text-lg font-medium text-text">User Activity</h2>
            </div>
            <div className="flex">
              <div className="w-full flex items-center flex-row ">
                <button
                  onClick={toggleModalFilter}
                  className="w-full sm:w-auto action-btn flex items-center justify-center gap-2 px-4 py-1 text-sm font-medium   hover:bg-[#02256d] text-[#02256d] hover:text-white border-2 border-[#02256d]  rounded-lg"
                  type="button"
                >
                  <MdFilterList className="w-5 h-5" /> Filter
                </button>

                {/* Filter Modal */}
                {isModalFilter && (
                  <div
                    id="crud-modal"
                    className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden bg-gray-900 bg-opacity-50"
                  >
                    <div className="relative p-4 w-full max-w-md h-auto">
                      {/* Modal Content */}
                      <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                        {/* Modal Header */}
                        <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                            Filter User
                          </h3>
                          <button
                            type="button"
                            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            onClick={toggleModalFilter}
                          >
                            <IoClose className="w-5 h-5" />
                          </button>
                        </div>

                        {/* Modal Body */}
                        <form onSubmit={handleFilter} className="p-4 md:p-5">
                          <div className="grid gap-4 mb-4 grid-cols-1 sm:grid-cols-2">
                            <div>
                              <label
                                htmlFor="dateFrom"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Date From
                              </label>
                              <input
                                type="date"
                                id="dateFrom"
                                defaultValue={dates?.fromDate}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                onClick={(e) => e.target.showPicker()} // Opens the calendar picker
                                required
                              />
                            </div>
                            <div>
                              <label
                                htmlFor="dateTo"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Date to
                              </label>
                              <input
                                type="date"
                                id="dateTo"
                                defaultValue={dates?.toDate}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                onClick={(e) => e.target.showPicker()} // Opens the calendar picker
                                required
                              />
                            </div>
                          </div>
                          <button
                            type="submit"
                            className="w-full mt-2 justify-center	 text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                          >
                            Submit
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* Tabs Section */}
          <div>
            <ul
              className=" flex flex-wrap -mb-px text-sm gap-2 font-medium text-center"
              role="tablist"
            >
              {/* All Tab */}
              <li className="mr-4" role="presentation">
                <button
                  className={`px-4 py-1 rounded-lg transition-all duration-200 ${
                    activeTab === "all"
                      ? "bg-[#02256d] text-white shadow-md"
                      : "bg-gray-100 text-gray-500 hover:bg-gray-200"
                  }`}
                  id="all"
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "all"}
                  onClick={() => handleTabClick("all")}
                >
                  All
                </button>
              </li>

              {/* Register Tab */}
              <li className="mr-4" role="presentation">
                <button
                  className={`px-4 py-1 rounded-lg transition-all duration-200 ${
                    activeTab === "Register"
                      ? "bg-[#02256d] text-white shadow-md"
                      : "bg-gray-100 text-gray-500 hover:bg-gray-200"
                  }`}
                  id="Register"
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "Register"}
                  onClick={() => handleTabClick("Register")}
                >
                  Register
                </button>
              </li>

              {/* Login Tab */}
              <li className="mr-4" role="presentation">
                <button
                  className={`px-4 py-1 rounded-lg transition-all duration-200 ${
                    activeTab === "Login"
                      ? "bg-[#02256d] text-white shadow-md"
                      : "bg-gray-100 text-gray-500 hover:bg-gray-200"
                  }`}
                  id="Login"
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "Login"}
                  onClick={() => handleTabClick("Login")}
                >
                  Login
                </button>
              </li>
              {/* Rdp Details Tab */}
              <li className="mr-4" role="presentation">
                <button
                  className={`px-4 py-1 rounded-lg transition-all duration-200 ${
                    activeTab === "Rdp Details"
                      ? "bg-[#02256d] text-white shadow-md"
                      : "bg-gray-100 text-gray-500 hover:bg-gray-200"
                  }`}
                  id="Rdp_Details"
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "Rdp Details"}
                  onClick={() => handleTabClick("Rdp Details")}
                >
                  Rdp details
                </button>
              </li>
              {/* User details Tab */}
              <li className="mr-4" role="presentation">
                <button
                  className={`px-4 py-1 rounded-lg transition-all duration-200 ${
                    activeTab === "User details"
                      ? "bg-[#02256d] text-white shadow-md"
                      : "bg-gray-100 text-gray-500 hover:bg-gray-200"
                  }`}
                  id="User_details"
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "User details"}
                  onClick={() => handleTabClick("User details")}
                >
                  Client details
                </button>
              </li>
              {/* Logout Tab */}
              <li className="mr-4" role="presentation">
                <button
                  className={`px-4 py-1 rounded-lg transition-all duration-200 ${
                    activeTab === "Logout"
                      ? "bg-[#02256d] text-white shadow-md"
                      : "bg-gray-100 text-gray-500 hover:bg-gray-200"
                  }`}
                  id="Logout"
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "Logout"}
                  onClick={() => handleTabClick("Logout")}
                >
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="p-2 bg-[#cbd5e0]">
        <DashboardTab
          userHeader={userHeader}
          userProducts={activityList}
          loading={activities.loading}
          totalDocument={activities.totalcount}
          filter={filterQuery}
          setFilter={setFilterQuery}
        />
        </div>
      </div>
    </div>
  );
};

export default UserActivity;
